import { render } from "./buyResourceModal.vue?vue&type=template&id=2cd2cc2e"
import script from "./buyResourceModal.vue?vue&type=script&lang=js"
export * from "./buyResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/buyResourceModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cd2cc2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cd2cc2e', __exports__)) {
    console.log('reload')
    api.reload('2cd2cc2e', __exports__)
  }
  
  module.hot.accept("./buyResourceModal.vue?vue&type=template&id=2cd2cc2e", () => {
    console.log('re-render')
    api.rerender('2cd2cc2e', render)
  })

}


export default __exports__